import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'stakeholder.analysis.details',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'stakeholder.details',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 300,
          },
        ],
      },
    },
    description: 'View and edit the details of a single stakeholder',
    name: 'Details',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
